import { createTheme } from '@material-ui/core/styles';

const journeythatTheme = createTheme({
  typography: {
    fontFamily: ["'CircularXX', sans-serif"].join(','),
  },
  palette: {
    primary: {
      main: '#FD7F64',
    },
  },
  overrides: {
    MuiTypography: {
      h6: {
        marginBottom: 8,
      },
    },
    MuiFormControl: {
      root: {
        marginBottom: 16,
      },
    },
    MuiCardHeader: {
      title: {
        fontSize: '1rem',
      },
      subheader: {
        fontSize: '1rem',
      },
    },
  },
});

export default journeythatTheme;
